import { IstariAiStarIcon } from "~/assets/svg";
import { cn } from "~/utils/cn";

interface IstariAiAvatarProps {
  size?: "lg" | "sm";
  className?: string;
}

// The star spans 70% of the circle at every size, as in the 80px and 40px design
// variants, so the small one is a faithful scale-down of the large one.
export function IstariAiAvatar({ size = "lg", className }: IstariAiAvatarProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "bg-muted border-background flex shrink-0 items-center justify-center rounded-full border-[1.33px]",
        size === "lg" ? "size-20" : "size-10",
        className,
      )}
    >
      <IstariAiStarIcon className="text-primary h-auto w-[70%]" />
    </div>
  );
}
